<template>
  <div>
      <CkEditor :editor="editor" :value="value"
                @input="handleInput"
                :config="editorConfig"/>
  </div>
</template>


<script>
import Vue from 'vue'
import CKEditor from '@ckeditor/ckeditor5-vue2';
import {ClassicEditor} from '@ckeditor/ckeditor5-editor-classic';

import {Autoformat} from '@ckeditor/ckeditor5-autoformat';
import {Bold, Italic, Subscript, Superscript, Underline, Code, Strikethrough} from '@ckeditor/ckeditor5-basic-styles';
import {BlockQuote} from '@ckeditor/ckeditor5-block-quote';
import {Font} from "@ckeditor/ckeditor5-font";
import {Essentials} from '@ckeditor/ckeditor5-essentials';
import {Heading, HeadingButtonsUI} from '@ckeditor/ckeditor5-heading';
import {Image, ImageUpload} from '@ckeditor/ckeditor5-image';
import {Link} from '@ckeditor/ckeditor5-link';
import {List} from '@ckeditor/ckeditor5-list';
import {Paragraph} from '@ckeditor/ckeditor5-paragraph';
import {Alignment} from '@ckeditor/ckeditor5-alignment';
import {Table, TableToolbar} from '@ckeditor/ckeditor5-table';
import {Base64UploadAdapter} from '@ckeditor/ckeditor5-upload';
import colors from "@/components/Editor/colors";

export default {
  name: 'RichEditor',
  components: {
    CkEditor: CKEditor.component
  },
  data() {
    return {
      editor: ClassicEditor,
      editorConfig: {
        plugins: [
          Image,
          Table,
          TableToolbar,
          Essentials,
          Subscript,
          Superscript,
          Code,
          Underline,
          Strikethrough,
          Autoformat,
          Font,
          Bold,
          Italic,
          BlockQuote,
          Heading,
          HeadingButtonsUI,
          Link,
          List,
          Paragraph,
          Alignment,
          Base64UploadAdapter,
          ImageUpload,
        ],
        toolbar: {
          items: [
            'bold',
            'italic',
            'underline',
            'strikethrough',
            'alignment',
            '|',
            'blockQuote',
            'code',
            '|',
            'bulletedList',
            'numberedList',
            '|',
            'heading', 'heading1', 'heading2',
            'subscript',
            'superscript',
            '|',
            'fontFamily',
            'fontColor',
            'fontBackgroundColor',
            'fontSize',
            '|',
            'insertTable',
            '|',
            'link',
            'uploadImage'
          ],
          shouldNotGroupWhenFull: true
        },
        heading: {
          options: [
            {model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph'},
            {model: 'heading1', view: 'h2', title: 'Heading 1'},
            {model: 'heading2', view: 'h3', title: 'Heading 2'},
            {model: 'heading3', view: 'h4', title: 'Heading 3'},
            {model: 'heading4', view: 'h5', title: 'Heading 4'},
            {model: 'heading5', view: 'h6', title: 'Heading 5'},
          ]
        },
        fontFamily: {
          options: [
            'default', 'Serif', 'Sans-serif', 'Monospace'
          ]
        },
        fontSize: {
          options: [
            9,
            11,
            13,
            'default',
            17,
            19,
            21
          ]
        },
        fontColor: colors.colors,
        fontBackgroundColor: colors.colors,
        table: {
          contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells']
        },
      },
    }
  },
  props: ['value'],
  methods: {
    handleInput(value) {
      this.$emit('input', value)
    }
  }
}
</script>

